<template>
  <img
    class="LanguageSelectorButton"
    data-testid="language-selector-button"
    v-if="showFlag"
    :src="store.currentLocale.icon"
    :alt="store.currentLocale.title"
    @click="onFlagClick">
</template>


<script>
import { store } from '@/app/store';
import { useUiStore } from '@/app/stores/ui';
import { payment } from '@/services/Payment';
import { printing } from '@/services/Printing';
import { sentryService } from '@/services/telemetry/sentry';

export default {
  setup() {
    return { ui: useUiStore() };
  },
  data() {
    return {
      store,
    };
  },
  computed: {
    showFlag() {
      return (
        this.store.currentLocale?.code && this.store.enabledLocales.length > 1
      );
    },
  },
  methods: {
    onFlagClick() {
      const isOpening = !this.ui.isLanguageSelectorOpen;

      // Block opening the language selector during payment or printing.
      // Changing locale mid-payment aborts the Stripe terminal flow and can
      // leave the reader in a bad state. During printing, locale change
      // re-renders the step and can disrupt the print queue.
      if (
        isOpening &&
        (payment.isPaymentInProgress || printing.isPrintingInProgress)
      ) {
        sentryService.addBreadcrumb(
          'ui.interaction',
          'Language selector blocked (protected step)',
          {
            current_locale: this.store.currentLocale?.code,
            payment_in_progress: payment.isPaymentInProgress,
            printing_in_progress: printing.isPrintingInProgress,
          }
        );
        return;
      }

      sentryService.addBreadcrumb(
        'ui.interaction',
        'Language selector toggled',
        {
          action: isOpening ? 'opened' : 'closed',
          current_locale: this.store.currentLocale?.code,
        }
      );

      isOpening
        ? this.ui.showLanguageSelector()
        : this.ui.hideLanguageSelector();
    },
  },
};
</script>


<style scoped>
.LanguageSelectorButton {
  width: 3.8rem;
  height: 2.5rem;
  border-radius: 0.22rem;
  object-fit: cover;
  object-position: center;
  display: block;
  cursor: pointer;
  box-shadow: 0 0.2rem 0.2rem rgba(var(--Kiosk--tint-color-rgb), 0.2);
  margin-top: 1.6rem;
  margin-right: 1.5rem;
  transform: var(--kiosk-language-button-transform);
  transform-origin: var(--kiosk-language-button-transform-origin);
}
</style>
